import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BreadcrumbComponent } from './breadcrumb.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    BreadcrumbComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
  ],
  exports: [
    BreadcrumbComponent,
  ],
  providers: [],
})
export class BreadcrumbModule {}



// WEBPACK FOOTER //
// ./src/app/common/components/BreadcrumbComponent/breadcrumb.module.ts